/* eslint-disable import/no-unresolved */
import { objectFromArray } from '../helpers';
import * as taxDocumentsActions from '../actions/taxDocuments';

export const initialState = {
  inflight: false,
  byId: {},
  allIds: [],
  lastUpdated: null,
};

const TaxDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case taxDocumentsActions.REQUEST_TAX_DOCUMENTS:
      return {
        ...state,
        inflight: true,
      };
    case taxDocumentsActions.RECEIVE_TAX_DOCUMENTS:
      return {
        ...state,
        inflight: false,
        byId: objectFromArray(action.taxDocuments, (taxDocument) => taxDocument.id),
        allIds: action.taxDocuments.map((taxDocument) => taxDocument.id),
        lastUpdated: action.receivedAt,
      };
    default:
      return state;
  }
};

export default TaxDocumentsReducer;
